<div class="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 backdrop-blur-sm" *ngIf="state === 0">
    
    <div class="bg-white w-full rounded-t-3xl shadow-2xl overflow-hidden flex flex-col h-[80vh] relative">
        
        <div class="w-full flex justify-center pt-3 pb-1">
            <div class="w-12 h-1.5 bg-gray-200 rounded-full animate-pulse"></div>
        </div>

        <div class="px-6 pb-4 pt-2 flex items-start justify-between">
            <div class="flex gap-4 items-center w-full">
                <div class="flex-shrink-0 w-14 h-14 bg-gray-200 rounded-xl animate-pulse"></div>
                
                <div class="flex flex-col gap-2 w-full mt-1">
                    <div class="h-5 bg-gray-200 rounded w-3/5 animate-pulse"></div> <div class="flex gap-2">
                        <div class="h-4 bg-gray-100 rounded w-16 animate-pulse"></div> <div class="h-4 bg-gray-100 rounded w-20 animate-pulse"></div> </div>
                    <div class="h-3 bg-gray-100 rounded w-4/5 animate-pulse"></div> </div>
            </div>
            <div class="w-9 h-9 bg-gray-100 rounded-full animate-pulse flex-shrink-0 ml-2"></div>
        </div>

        <div class="w-full h-48 bg-gray-200 mb-6 animate-pulse"></div>

        <div class="px-5 mb-6">
            <div class="grid grid-cols-2 gap-3">
                <div class="h-24 bg-gray-50 border border-gray-100 rounded-2xl p-3 flex flex-col items-center justify-center gap-2 animate-pulse">
                    <div class="h-3 w-20 bg-gray-200 rounded"></div>
                    <div class="h-8 w-16 bg-gray-300 rounded"></div>
                </div>
                <div class="h-24 bg-gray-50 border border-gray-100 rounded-2xl p-3 flex flex-col items-center justify-center gap-2 animate-pulse">
                    <div class="h-3 w-16 bg-gray-200 rounded"></div>
                    <div class="h-8 w-16 bg-gray-300 rounded"></div>
                </div>
            </div>
        </div>

        <div class="flex-1 overflow-hidden flex flex-col">
            <div class="px-5 mb-3 flex items-center justify-between">
                <div class="h-6 w-32 bg-gray-200 rounded animate-pulse"></div>
                <div class="h-6 w-16 bg-gray-100 rounded animate-pulse"></div>
            </div>

            <div class="px-5 flex flex-col gap-3">
                <div class="bg-white border border-gray-100 rounded-2xl p-4 flex items-center justify-between shadow-sm">
                    <div class="space-y-2 w-full">
                        <div class="h-5 bg-gray-200 rounded w-1/2 animate-pulse"></div>
                        <div class="h-4 bg-gray-100 rounded w-1/3 animate-pulse"></div>
                    </div>
                    <div class="w-20 h-9 bg-gray-200 rounded-xl animate-pulse flex-shrink-0"></div>
                </div>
                <div class="bg-white border border-gray-100 rounded-2xl p-4 flex items-center justify-between shadow-sm">
                    <div class="space-y-2 w-full">
                        <div class="h-5 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                        <div class="h-4 bg-gray-100 rounded w-1/4 animate-pulse"></div>
                    </div>
                    <div class="w-20 h-9 bg-gray-200 rounded-xl animate-pulse flex-shrink-0"></div>
                </div>
            </div>
        </div>

        <div class="border-t border-gray-100 bg-white h-20 w-full flex justify-around items-start pt-3 absolute bottom-0 z-10">
            <div class="flex flex-col items-center gap-1 w-full opacity-50">
                <div class="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                <div class="w-8 h-2 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div class="flex flex-col items-center gap-1 w-full opacity-50">
                <div class="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                <div class="w-10 h-2 bg-gray-200 rounded animate-pulse"></div>
            </div>
        </div>

    </div>
</div>


<div class="fixed inset-0 z-[70] bg-gray-50 flex flex-col h-[100dvh]" *ngIf="state > 0">

    <div class="bg-white px-4 py-3 flex items-center gap-4 shadow-sm z-20 sticky top-0 border-b border-gray-100">
        <div class="w-10 h-10 rounded-full bg-gray-200 animate-pulse flex-shrink-0"></div>
        <div class="h-6 bg-gray-200 rounded w-2/3 animate-pulse"></div>
    </div>

    <div class="flex-1 overflow-hidden flex flex-col pb-10">

        <div class="relative w-full h-56 bg-gray-300 animate-pulse flex-shrink-0">
             <div class="absolute bottom-3 w-full flex justify-center gap-2">
                 <div class="w-4 h-1.5 bg-white/50 rounded-full"></div>
                 <div class="w-1.5 h-1.5 bg-white/50 rounded-full"></div>
                 <div class="w-1.5 h-1.5 bg-white/50 rounded-full"></div>
             </div>
        </div>

        <div class="px-4 -mt-6 relative z-10 flex flex-col gap-4">

            <div class="bg-white rounded-2xl shadow-lg p-5 border border-gray-100">
                <div class="flex items-center gap-2 mb-4">
                    <div class="w-1 h-5 bg-gray-300 rounded-full"></div>
                    <div class="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div>

                <div class="grid grid-cols-3 gap-3 mb-4">
                    <div class="h-20 bg-gray-100 rounded-xl border border-gray-200 animate-pulse flex flex-col items-center justify-center gap-2">
                        <div class="w-8 h-2 bg-gray-300 rounded"></div>
                        <div class="w-10 h-6 bg-gray-300 rounded"></div>
                    </div>
                    <div class="h-20 bg-gray-100 rounded-xl border border-gray-200 animate-pulse flex flex-col items-center justify-center gap-2">
                        <div class="w-8 h-2 bg-gray-300 rounded"></div>
                        <div class="w-10 h-6 bg-gray-300 rounded"></div>
                    </div>
                    <div class="h-20 bg-gray-100 rounded-xl border border-gray-200 animate-pulse flex flex-col items-center justify-center gap-2">
                        <div class="w-8 h-2 bg-gray-300 rounded"></div>
                        <div class="w-10 h-6 bg-gray-300 rounded"></div>
                    </div>
                </div>

                <div class="pt-4 border-t border-gray-100 flex justify-between items-center">
                    <div class="flex items-center gap-2">
                        <div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
                        <div class="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div class="h-5 w-24 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>

            <div class="mt-2">
                <div class="flex justify-between items-center mb-3 px-1">
                    <div class="h-6 w-32 bg-gray-300 rounded animate-pulse"></div>
                    <div class="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
                </div>

                <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div class="grid grid-cols-4 bg-gray-50 border-b border-gray-100 py-3 gap-2 px-2">
                        <div class="h-3 bg-gray-300 rounded animate-pulse"></div>
                        <div class="h-3 bg-gray-300 rounded animate-pulse"></div>
                        <div class="h-3 bg-gray-300 rounded animate-pulse"></div>
                        <div class="h-3 bg-gray-300 rounded animate-pulse"></div>
                    </div>

                    <div class="flex flex-col">
                        <div class="grid grid-cols-4 py-3.5 border-b border-gray-100 items-center">
                            <div class="flex justify-center"><div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                        </div>
                        <div class="grid grid-cols-4 py-3.5 border-b border-gray-100 items-center">
                            <div class="flex justify-center"><div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                        </div>
                        <div class="grid grid-cols-4 py-3.5 border-b border-gray-100 items-center">
                            <div class="flex justify-center"><div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                            <div class="flex justify-center"><div class="w-6 h-4 bg-gray-100 rounded animate-pulse"></div></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

